import React from 'react';
import Box from '@mui/material/Box';
import { string } from 'prop-types';
import Loader from '@/components/common/Loader';
import { CompanyTeamMemberStatus } from '@/propTypes';

const TEAM_MEMBER_TABLE_LOADER_SIZE = '30px';

function TeamMemberLoaderCell({ status, justifyContent }) {
  return (
    <Box
      height={TEAM_MEMBER_TABLE_LOADER_SIZE}
      display="flex"
      flex="1"
      flexDirection="row"
      justifyContent={justifyContent}
    >
      <Loader
        isVisible={Boolean(status?.isFetching)}
        size={TEAM_MEMBER_TABLE_LOADER_SIZE}
      />
    </Box>
  );
}

TeamMemberLoaderCell.propTypes = {
  status: CompanyTeamMemberStatus,
  justifyContent: string,
};

TeamMemberLoaderCell.defaultProps = {
  status: {
    dataLoaded: false,
    isFetching: false,
    error: null,
  },
  justifyContent: 'flex-end',
};

export default TeamMemberLoaderCell;
